import { render, staticRenderFns } from "./Imagen.html?vue&type=template&id=167d14b6&scoped=true&"
import script from "./Imagen.js?vue&type=script&lang=js&"
export * from "./Imagen.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d14b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/SVN/Software/WebPages/VueAnsul/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
